import { LAST_EVENT, LUMA_FOLLOW_URL, NEXT_EVENT } from "../config/events";
import { LumaCalendarEmbed } from "./LumaCalendarEmbed";

const cardClass =
  "rounded-xl border border-slate-800/80 bg-slate-900/40 px-5 py-5 text-left";

export const LumaSection = () => {
  return (
    <section className={cardClass}>
      <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
        {NEXT_EVENT.label}
      </p>
      <p className="mt-2 text-sm text-slate-400">
        Next date TBD. Subscribe to get notified when registration opens.
      </p>
      {LUMA_FOLLOW_URL ? (
        <a
          href={LUMA_FOLLOW_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 inline-flex rounded-lg bg-emerald-500 px-4 py-2 text-sm font-medium text-slate-950 transition hover:bg-emerald-400"
        >
          Subscribe on Luma
        </a>
      ) : null}
      <div className="-mx-5 mt-5">
        <LumaCalendarEmbed />
      </div>
      <div className="mt-5 border-t border-slate-800/80 pt-4">
        <p className="text-xs font-medium uppercase tracking-wide text-slate-600">
          {LAST_EVENT.label}
        </p>
        <p className="mt-1 text-sm text-slate-400">
          {LAST_EVENT.date} · {LAST_EVENT.venue}
        </p>
      </div>
    </section>
  );
};
